// extracted by mini-css-extract-plugin
export var active = "_2m-2";
export var dot = "_2m-1";
export var walkthrough = "_2m-0";